import { useIndexedDB } from "react-indexed-db-hook";
import { useEffect, useState } from "react";

export default function useFavoriteZone() {
    const dbValues = useIndexedDB("favoriteZones");
    const { getAll, add: _add, deleteRecord, getByIndex: _getByIndex, clear: clearAll, getByID } = dbValues;

    const [zones, setZones] = useState([]);

    const reload = () => {
        getAll()
            .then((valuesFromDB) => {
                setZones(valuesFromDB);
            })
            .catch(() => setZones([]));
    };

    useEffect(() => {
        reload();
    }, [dbValues]);

    const add = async (item: any) => {
        await _add(item);
        reload();
    };

    const getByIndex = (indexName: string, key: any) => {
        if (indexName === "id") {
            key = parseInt(key);
        }
        return zones.find((zone) => zone[indexName] === key);
    };

    const deleteByIndex = async (indexName: string, key: any) => {
        if (indexName === "id") {
            await deleteRecord(key);
        } else {
            const entity = await _getByIndex(indexName, key);
            await deleteRecord(entity.id);
        }
        reload();
    };

    return {
        zones,
        add,
        deleteRecord,
        getByIndex,
        getByIndexAsync: _getByIndex,
        deleteByIndex,
        clearAll,
        reload,
    };
}
